/* ==========================================
   collection.js — Filtros, ordenamiento, paginación AJAX
   Storefront Filtering API nativa de Shopify.
   Dependencias: theme.js (debounce, trapFocus, showOverlay, hideOverlay)
   ========================================== */

(function() {
  var section = document.querySelector('[data-collection-section]');
  if (!section) return;

  var sectionId = section.dataset.sectionId;
  var grid = section.querySelector('[data-collection-grid]');
  var filterForm = section.querySelector('[data-filter-form]');
  var sortSelect = section.querySelector('[data-sort-select]');
  var activeFiltersContainer = section.querySelector('[data-active-filters]');
  var clearAllBtns = section.querySelectorAll('[data-clear-filters]');
  var resultsCount = section.querySelector('[data-results-count]');
  var paginationContainer = section.querySelector('[data-collection-pagination]');
  var filterDrawer = section.querySelector('[data-filter-drawer]');
  var filterDrawerToggle = section.querySelector('[data-filter-drawer-toggle]');
  var filterDrawerClose = section.querySelector('[data-filter-drawer-close]');
  var releaseFocusFn = null;

  /* ---- Filtro de color (propio del tema, no usa la Storefront Filtering API) ----
     El filtro de "Color" se arma en Liquid leyendo directo cada producto (color_unico o
     color/color2/color3) porque los filtros nativos de Shopify venían incompletos. Como
     Shopify no sabe de este parámetro, el filtrado se hace aquí en el navegador: se guarda
     en el querystring (?color=Rojo,Negro) para poder compartir/recargar la URL, y se
     muestran/ocultan las tarjetas de la grilla comparando con su atributo data-colors.
     La grilla normal solo trae la página actual (24 productos) — si un producto de ese
     color vive en la página 2 o 3, un filtro que solo mirara la página cargada nunca lo
     encontraría. Por eso, en cuanto se elige un color, se cargan TODAS las páginas de la
     colección (ensureAllProductsLoaded) antes de filtrar, así el color busca en el
     catálogo completo de esta vista, no solo en lo que ya estaba en pantalla. */
  var COLOR_PARAM = 'color';

  function getSelectedColors() {
    var raw = new URLSearchParams(window.location.search).get(COLOR_PARAM);
    return raw ? raw.split(',').filter(Boolean) : [];
  }

  /* Trae el resto de páginas de la colección (2, 3, ...) y añade sus tarjetas a la
     grilla, para que el filtro de color pueda buscar en todos los productos, no solo en
     los ya renderizados. Se ejecuta una sola vez por carga de grilla (grid.dataset.colorExpanded). */
  function ensureAllProductsLoaded() {
    if (!grid) return Promise.resolve();
    if (grid.dataset.colorExpanded === '1') return Promise.resolve();
    grid.dataset.colorExpanded = '1';
    var totalPages = parseInt(section.dataset.totalPages || '1', 10) || 1;
    if (totalPages <= 1) return Promise.resolve();
    var baseUrl = new URL(window.location.href);
    /* La página actual ya está en el DOM (por eso se salta) — puede ser cualquiera,
       no siempre la 1 (p.ej. si se activa un color estando en la página 2). */
    var currentPage = parseInt(baseUrl.searchParams.get('page') || '1', 10) || 1;
    var fetches = [];
    for (var p = 1; p <= totalPages; p++) {
      if (p === currentPage) continue;
      var pageUrl = new URL(baseUrl);
      if (p === 1) { pageUrl.searchParams.delete('page'); } else { pageUrl.searchParams.set('page', String(p)); }
      pageUrl.searchParams.delete(COLOR_PARAM);
      var fetchUrl = pageUrl.toString() + (pageUrl.search ? '&' : '?') + 'sections=' + sectionId;
      fetches.push(
        fetch(fetchUrl)
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var html = data[sectionId];
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var pageGrid = doc.querySelector('[data-collection-grid]');
            if (pageGrid && grid) {
              /* pageGrid.children es una HTMLCollection viva: hay que copiarla a un
                 array normal antes de moverlos con appendChild, porque si no, la
                 colección se encoge mientras se recorre y se saltan la mitad. */
              var pageCards = Array.prototype.slice.call(pageGrid.children);
              pageCards.forEach(function(child) {
                grid.appendChild(child);
              });
            }
          })
          .catch(function(err) { console.error('Color filter: error cargando página extra', err); })
      );
    }
    return Promise.all(fetches);
  }

  function applyColorFilter() {
    var selected = getSelectedColors();
    var cards = grid ? grid.querySelectorAll('[data-colors]') : [];
    var visibleCount = 0;
    cards.forEach(function(card) {
      /* Se oculta el contenedor de la grilla (la celda), no solo la tarjeta interna —
         si no, la celda vacía sigue ocupando su lugar y deja huecos en el layout. */
      var cell = card.closest('.collection-main__product') || card;
      if (!selected.length) { cell.style.display = ''; visibleCount++; return; }
      var cardColors = (card.dataset.colors || '').split('|').filter(Boolean);
      var match = cardColors.some(function(c) { return selected.indexOf(c) !== -1; });
      cell.style.display = match ? '' : 'none';
      if (match) visibleCount++;
    });
    var swatches = section.querySelectorAll('[data-color-toggle]');
    swatches.forEach(function(sw) {
      var isOn = selected.indexOf(sw.dataset.colorToggle) !== -1;
      sw.classList.toggle('is-active', isOn);
      var input = sw.querySelector('input');
      if (input) input.checked = isOn;
    });
    /* Si el color elegido no tiene coincidencias en TODA la colección (ya con todas las
       páginas cargadas), se avisa dentro de la grilla en vez de dejarla vacía, para que
       la paginación no "suba" de lugar. */
    var emptyNotice = grid ? grid.querySelector('[data-color-empty]') : null;
    if (selected.length && visibleCount === 0) {
      if (!emptyNotice && grid) {
        emptyNotice = document.createElement('div');
        emptyNotice.setAttribute('data-color-empty', '');
        emptyNotice.className = 'collection-main__color-empty';
        emptyNotice.textContent = 'No hay productos con ese color en esta colección. Prueba con otro color o quita el filtro.';
        grid.appendChild(emptyNotice);
      }
      if (emptyNotice) emptyNotice.style.display = '';
    } else if (emptyNotice) {
      emptyNotice.style.display = 'none';
    }
  }

  function bindColorSwatches() {
    var swatches = section.querySelectorAll('[data-color-toggle]');
    swatches.forEach(function(sw) {
      sw.addEventListener('click', function(e) {
        e.preventDefault();
        var color = sw.dataset.colorToggle;
        var selected = getSelectedColors();
        var idx = selected.indexOf(color);
        if (idx === -1) { selected.push(color); } else { selected.splice(idx, 1); }
        var url = new URL(window.location.href);
        if (selected.length) { url.searchParams.set(COLOR_PARAM, selected.join(',')); }
        else { url.searchParams.delete(COLOR_PARAM); }
        history.pushState({}, '', url.toString());
        if (selected.length) {
          /* Trae el resto de páginas (si hace falta) antes de decidir qué se ve. */
          ensureAllProductsLoaded().then(applyColorFilter);
        } else {
          /* Sin colores activos: se vuelve a la grilla nativa de una sola página
             (fetchAndUpdate reemplaza toda la grilla, descartando las páginas extra
             que se hayan agregado mientras el filtro de color estaba activo). */
          fetchAndUpdate();
        }
      });
    });
  }

  /* ---- Filter form submission ---- */
  if (filterForm) {
    filterForm.addEventListener('input', debounce(function() {
      fetchAndUpdate();
    }, 500));

    filterForm.addEventListener('submit', function(e) {
      e.preventDefault();
      fetchAndUpdate();
    });
  }

  /* ---- Sorting ---- */
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      fetchAndUpdate();
    });
  }

  /* ---- Build URL from form + sort ---- */
  function buildUrl() {
    var url = new URL(window.location.href);
    var params = new URLSearchParams();

    /* Collect filter inputs */
    if (filterForm) {
      var formData = new FormData(filterForm);
      var entries = formData.entries();
      var entry = entries.next();
      while (!entry.done) {
        var key = entry.value[0];
        var val = entry.value[1];
        if (val !== '' && val !== undefined) {
          params.append(key, val);
        }
        entry = entries.next();
      }
    }

    /* Sort */
    if (sortSelect && sortSelect.value) {
      params.set('sort_by', sortSelect.value);
    }

    /* Color: Shopify no lo conoce, pero se preserva en la URL para que siga filtrando. */
    var currentColor = new URLSearchParams(window.location.search).get(COLOR_PARAM);
    if (currentColor) { params.set(COLOR_PARAM, currentColor); }

    url.search = params.toString();
    return url.toString();
  }

  /* ---- Fetch and replace ---- */
  function fetchAndUpdate(url) {
    if (!url) {
      url = buildUrl();
    } else {
      /* URL explícita (paginación, quitar un filtro): conserva el color activo también. */
      var explicitUrl = new URL(url, window.location.origin);
      var currentColor = new URLSearchParams(window.location.search).get(COLOR_PARAM);
      if (currentColor) { explicitUrl.searchParams.set(COLOR_PARAM, currentColor); }
      url = explicitUrl.toString();
    }

    section.classList.add('is-loading');

    /* Update browser URL */
    history.pushState({}, '', url);

    /* Fetch section rendering */
    var fetchUrl = url + (url.includes('?') ? '&' : '?') + 'sections=' + sectionId;

    fetch(fetchUrl)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var html = data[sectionId];
        if (!html) return;

        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        /* Replace grid */
        var newGrid = doc.querySelector('[data-collection-grid]');
        if (newGrid && grid) {
          grid.innerHTML = newGrid.innerHTML;
          /* Grilla nueva de una sola página: hay que volver a cargar el resto si el
             filtro de color sigue activo (ver ensureAllProductsLoaded más abajo). */
          grid.dataset.colorExpanded = '';
        }

        /* El total de páginas puede cambiar al combinar con otro filtro (Talla, Proveedor...). */
        var newSection = doc.querySelector('[data-collection-section]');
        if (newSection && newSection.dataset.totalPages) {
          section.dataset.totalPages = newSection.dataset.totalPages;
        }

        /* Replace active filters */
        var newActive = doc.querySelector('[data-active-filters]');
        if (newActive && activeFiltersContainer) {
          activeFiltersContainer.innerHTML = newActive.innerHTML;
          bindRemoveFilterButtons();
        }

        /* Replace results count */
        var newCount = doc.querySelector('[data-results-count]');
        if (newCount && resultsCount) {
          resultsCount.innerHTML = newCount.innerHTML;
        }

        /* Replace pagination */
        var newPagination = doc.querySelector('[data-collection-pagination]');
        if (newPagination && paginationContainer) {
          paginationContainer.innerHTML = newPagination.innerHTML;
          bindPaginationLinks();
        }

        /* Replace filter form (to update counts, checked states) */
        var newFilterForm = doc.querySelector('[data-filter-form]');
        if (newFilterForm && filterForm) {
          filterForm.innerHTML = newFilterForm.innerHTML;
        }

        /* Update sort select */
        var newSort = doc.querySelector('[data-sort-select]');
        if (newSort && sortSelect) {
          sortSelect.value = newSort.value;
        }

        /* La grilla y los swatches de color son nuevos: volver a enlazar y reaplicar.
           Si el color sigue activo, hay que volver a traer el resto de páginas (la
           grilla que acaba de llegar solo trae la página actual). */
        bindColorSwatches();
        if (getSelectedColors().length) {
          ensureAllProductsLoaded().then(applyColorFilter);
        } else {
          applyColorFilter();
        }
      })
      .catch(function(err) {
        console.error('Collection fetch error:', err);
        /* Fallback: full page navigation */
        window.location.href = url;
      })
      .finally(function() {
        section.classList.remove('is-loading');
        /* Scroll to top of grid */
        var gridTop = grid ? grid.getBoundingClientRect().top + window.scrollY - 100 : 0;
        window.scrollTo({ top: gridTop, behavior: 'smooth' });
      });
  }

  /* ---- Active filter remove buttons ---- */
  function bindRemoveFilterButtons() {
    var removeBtns = section.querySelectorAll('[data-remove-filter]');
    removeBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var url = btn.dataset.removeFilter || btn.href;
        if (url) fetchAndUpdate(url);
      });
    });
  }

  /* ---- Clear all filters (todos los botones: barra de activos y cabecera del drawer) ---- */
  Array.prototype.forEach.call(clearAllBtns, function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var url = btn.dataset.clearUrl || btn.getAttribute('href');
      /* "Limpiar todo" también quita el color (no es un filtro nativo de Shopify). */
      var clean = new URL(window.location.href);
      clean.searchParams.delete(COLOR_PARAM);
      history.replaceState({}, '', clean.toString());
      if (url) fetchAndUpdate(url);
    });
  });

  /* ---- Pagination links (AJAX) ---- */
  function bindPaginationLinks() {
    var paginationLinks = section.querySelectorAll('[data-collection-pagination] a');
    paginationLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        fetchAndUpdate(link.href);
      });
    });
  }

  /* ---- Price range inputs ---- */
  function initPriceRange() {
    var priceMin = section.querySelector('[data-price-min]');
    var priceMax = section.querySelector('[data-price-max]');
    if (priceMin) {
      priceMin.addEventListener('change', debounce(function() { fetchAndUpdate(); }, 500));
    }
    if (priceMax) {
      priceMax.addEventListener('change', debounce(function() { fetchAndUpdate(); }, 500));
    }
  }

  /* ---- Mobile filter drawer ---- */
  function openFilterDrawer() {
    if (!filterDrawer) return;
    filterDrawer.hidden = false;
    filterDrawer.classList.add('is-open');
    showOverlay();
    releaseFocusFn = trapFocus(filterDrawer);
    if (filterDrawerToggle) filterDrawerToggle.setAttribute('aria-expanded', 'true');
  }

  function closeFilterDrawer() {
    if (!filterDrawer) return;
    filterDrawer.classList.remove('is-open');
    filterDrawer.hidden = true;
    hideOverlay();
    if (releaseFocusFn) { releaseFocusFn(); releaseFocusFn = null; }
    if (filterDrawerToggle) {
      filterDrawerToggle.setAttribute('aria-expanded', 'false');
      filterDrawerToggle.focus();
    }
  }

  if (filterDrawerToggle) {
    filterDrawerToggle.addEventListener('click', function() {
      if (filterDrawer.hidden) { openFilterDrawer(); }
      else { closeFilterDrawer(); }
    });
  }

  if (filterDrawerClose) {
    filterDrawerClose.addEventListener('click', closeFilterDrawer);
  }

  if (filterDrawer) {
    filterDrawer.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeFilterDrawer();
    });
  }

  document.addEventListener('drawer:close', closeFilterDrawer);

  /* ---- Browser back/forward ---- */
  window.addEventListener('popstate', function() {
    fetchAndUpdate(window.location.href);
  });

  /* ---- Init ---- */
  bindRemoveFilterButtons();
  bindPaginationLinks();
  initPriceRange();
  bindColorSwatches();
  /* Si la página se carga directo con ?color=... (link compartido, recarga), hay que
     traer el resto de páginas antes de filtrar — si no, solo busca en la página 1. */
  if (getSelectedColors().length) {
    ensureAllProductsLoaded().then(applyColorFilter);
  } else {
    applyColorFilter();
  }

})();
